import BookingReview from "../../legacy/pages/BookingReview";
import BookingSuccess from "../../legacy/pages/BookingSuccess";
import GuestDetailsPage from "../../legacy/pages/GuestDetailsPage";
import PaymentPage from "../../legacy/pages/PaymentPage";
import MobileBookingProgress from "../components/MobileBookingProgress";
import "../styles/mobile-theme.css";

function FlowShell({ step, activeStep, crumb, children }) {
  return <div className={`hv-mobile-booking-flow hv-mobile-booking-${step}`}>
    {activeStep >= 0 ? <MobileBookingProgress active={activeStep} crumb={crumb} /> : null}
    {children}
  </div>;
}

export const MobileTravelerInfo = () => <FlowShell step="traveler" activeStep={1} crumb="Home / Stays / Guest details"><GuestDetailsPage /></FlowShell>;
export const MobileBookingReview = () => <FlowShell step="review" activeStep={2} crumb="Home / Stays / Review"><BookingReview /></FlowShell>;
export const MobilePaymentMethod = () => <FlowShell step="payment" activeStep={3} crumb="Home / Stays / Payment"><PaymentPage /></FlowShell>;
export const MobileBookingSuccess = () => <FlowShell step="success" activeStep={3} crumb="Home / Stays / Confirmation"><BookingSuccess /></FlowShell>;
